import React from 'react';

const useDetailsWizard = () => {
    const [state, dispatch] = React.useReducer(reducer, initialState);

    const set = (payload) => {
        dispatch({ type: 'set', payload });
    };
    const patch = (payload) => {
        dispatch({ type: 'patch', payload });
    };
    React.useEffect(() => {}, []);
    return {
        state,
        patch,
        set,
    };
};

export default useDetailsWizard;

const reducer = (state, action) => {
    switch (action.type) {
        case 'patch':
            return { ...state, ...action.payload };
        case 'set':
            return action.payload;
        default:
            return state;
    }
};

const initialState = {
    ApplicantDOB: null,
    ApplicantFirstName: '',
    ApplicantLastName: '',
    GuardianFirstName: '',
    GuardianLastName: '',
    InvoiceDate: null,
    LNHAward: null,
    QuarterFrom: null,
    QuarterTo: null,
    Tuition: null,
    AttendanceRecordFileID: null,
};
